// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1juoW","newExpiryDate":"styles_newExpiryDate__3sPz8","footer":"styles_footer__n67_r"};